/*Generated from the `:::slide{key="1111dacf-db12-4f4e-a248-ceec6d06232f" slug="compound-strokes"}` (simplified/001/002/𠃊.mdx) directive. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      count: "2",
      children: _jsxs(html.p, {
        children: [_jsx(html.strong, {
          children: "Compound strokes",
          components: html
        }), " change directions as you write it."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "2",
      children: _jsx(html.p, {
        children: "Swipe next to learn your first compound stroke!",
        components: html
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
